import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WebhooksApiAdapter } from '../adapters/WebhooksApiAdapter';

export const useWebhookDeliveries = (endpointId: number | null) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new WebhooksApiAdapter(httpClient);

  return useQuery({
    queryKey: ['webhook-deliveries', endpointId],
    queryFn: () => adapter.getDeliveries(endpointId!),
    enabled: endpointId !== null,
    staleTime: 60 * 1000,
  });
};
